import type { ScheduleAiTheme } from 'src/theme/schedule-ai-overrides';

import { useTranslation } from 'react-i18next';

import { Stack, useTheme, Typography } from '@mui/material';

import { Iconify } from '../iconify';

interface PriorityProps {
  priority: 'NORMAL' | 'HIGH' | 'LOW';
}
export const Priority = ({ priority }: PriorityProps) => {
  const { t } = useTranslation('common');
  const theme: ScheduleAiTheme = useTheme();
  return (
    priority && (
      <Stack direction="row" spacing={1}>
        <Iconify
          icon="solar:flag-bold"
          sx={{
            '& path': {
              fill: theme.priority[priority].iconColor,
            },
          }}
        />
        <Typography variant="body2" color="text.primary">
          {t(`priority.${priority}`)}
        </Typography>
      </Stack>
    )
  );
};
